import { render, staticRenderFns } from "./ImageTranslate.vue?vue&type=template&id=38f92fda"
import script from "./ImageTranslate.vue?vue&type=script&lang=js"
export * from "./ImageTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports